export interface GqlCallable {
  called: boolean;
}

export interface GqlLoadable {
  loading: boolean;
}

export interface HasData {
  data: any;
}

/**
 * Is this query done giving me data?
 * @param query - Apollo Query response
 */
export const isQueryFinished = (query: GqlCallable & GqlLoadable) => query.called && !query.loading;
